export default __webpack_public_path__ + "static/media/caminhao.f7c1ffaa.jpg";